import { PropTypes } from 'prop-types';

import Box from '@mui/material/Box';

import DomainPrivacyProductCard from './components/DomainPrivacyProductCard';
import DomainProductCard from './components/DomainProductCard';
import EmailProductCard from './components/EmailProductCard';
import Section from './components/Section';
import WebsiteProductCard from './components/WebsiteProductCard';

import { PRODUCT_MODALS } from '../Home/constants';
import { MT_DATA_TRACKING, WEBSITE_PRODUCTS } from './utils/constants';

const Products = ({ entitlements, hasActiveWebsites, onLearnMoreClick }) => (
  <Section
    title="Tools for any small business"
    description="We have solutions to manage your online presence in one place."
  >
    <Box
      bgcolor="focus10.main"
      borderRadius={4}
      p={{
        xs: 1.5,
        lg: 2
      }}
      boxShadow="0px 4px 16px 2px rgba(0, 0, 0, 0.12)"
    >
      <Box
        gap={2}
        display="grid"
        gridTemplateColumns={{
          xs: '1fr',
          lg: '1fr 1fr'
        }}
      >
        <DomainProductCard
          isPurchased={entitlements.has(WEBSITE_PRODUCTS.DOMAIN)}
          onLearnMoreClick={onLearnMoreClick(PRODUCT_MODALS.DOMAIN_NAME_REG)}
          dataTrackingProps={MT_DATA_TRACKING}
        />
        <DomainPrivacyProductCard
          isPurchased={entitlements.has(WEBSITE_PRODUCTS.DOMAIN_PRIVACY)}
          isPurchaseAllowed={entitlements.has(WEBSITE_PRODUCTS.DOMAIN)}
          onLearnMoreClick={onLearnMoreClick(PRODUCT_MODALS.DOMAIN_NAME_PRIVACY)}
          dataTrackingProps={MT_DATA_TRACKING}
        />
        <EmailProductCard
          isPurchased={entitlements.has(WEBSITE_PRODUCTS.EMAIL)}
          isPurchaseAllowed={entitlements.has(WEBSITE_PRODUCTS.DOMAIN)}
          onLearnMoreClick={onLearnMoreClick(PRODUCT_MODALS.EMAIL)}
          dataTrackingProps={MT_DATA_TRACKING}
        />
        <WebsiteProductCard
          isPurchased={entitlements.has(WEBSITE_PRODUCTS.WEBSITE)}
          hasActiveWebsites={hasActiveWebsites}
          onLearnMoreClick={onLearnMoreClick(PRODUCT_MODALS.WEBSITE_DUDA)}
          dataTrackingProps={MT_DATA_TRACKING}
        />
      </Box>
    </Box>
  </Section>
);

Products.propTypes = {
  entitlements: PropTypes.shape({
    has: PropTypes.func.isRequired,
    get: PropTypes.func.isRequired
  }).isRequired,
  hasActiveWebsites: PropTypes.bool,
  onLearnMoreClick: PropTypes.func.isRequired
};

export default Products;
